import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.9628 18.4968C15.3782 19.8459 13.3242 20.66 11.08 20.66C6.06525 20.66 2 16.5947 2 11.58C2 6.56525 6.06525 2.5 11.08 2.5C16.0947 2.5 20.16 6.56525 20.16 11.58C20.16 13.8106 19.3557 15.8533 18.0212 17.434L22.3796 21.7924L21.319 22.8531L16.9628 18.4968ZM18.66 11.58C18.66 15.7663 15.2663 19.16 11.08 19.16C6.89368 19.16 3.5 15.7663 3.5 11.58C3.5 7.39368 6.89368 4 11.08 4C15.2663 4 18.66 7.39368 18.66 11.58Z",
		fill: "#79C912"
	})
});
export default SvgSearchIcon;
